import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Configuration } from '../configuration/configurations';
import { User } from '../_models';
import { UserService } from '../_services';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  providers: [Configuration, UserService]
})
export class HeaderComponent implements OnInit {

  currentUrl: string;
  public user: User;
  public userId: string;
  public loginName: string;
  public displayName: string;
  public clientcode: string;
  public rate: string;
  public Extensions: string;
  public clientName: string;
  public TaskEnabled: boolean;
  private isclientLogo: string = "";
  constructor(private router: Router,
    private _configuration: Configuration, private _userService: UserService) {
    router.events.subscribe((_: NavigationEnd) => this.currentUrl = _.url);
  }

  ngOnInit() {
    debugger;
    this.TaskEnabled = localStorage.getItem('TaskEnabled') == 'Y' ? true : false;
    this.userId = localStorage.getItem('user');
    this.loginName = localStorage.getItem('userName');
    this.displayName = localStorage.getItem('displayName');
    this.clientcode = localStorage.getItem('clientcode');
    this.rate = localStorage.getItem('rate');
    this.Extensions = localStorage.getItem('Extensions');
    this.clientName = localStorage.getItem('ClientName');
    let dnsname = localStorage.getItem("DnsName");
    let isfromdns = localStorage.getItem("isfromDns");
    if (localStorage.getItem("clientLogo")) {
      this.isclientLogo = localStorage.getItem("clientLogo");
    }
  }

  logout() {
    let dnsname = localStorage.getItem("DnsName");
    let isfromdns = localStorage.getItem("isfromDns");
    localStorage.removeItem("Authorization");
    localStorage.removeItem("role");
    localStorage.removeItem("user");
    localStorage.removeItem("userName");
    localStorage.removeItem("displayName");
    localStorage.removeItem("clientcode");
    localStorage.removeItem("rate");
    localStorage.removeItem("Extensions");
    localStorage.removeItem("clientPrimaryColor");
    localStorage.removeItem("clientSecondaryColor");
    localStorage.removeItem("PrimaryColor");
    localStorage.removeItem("SecondaryColor");
    localStorage.removeItem("clientLogo");
    localStorage.removeItem("ClientName");
    localStorage.removeItem("isfromDns");
    localStorage.removeItem("DnsName");
    localStorage.removeItem("currentUser");
    //if(dnsname != "" && isfromdns)
    //{

    //window.location.href = localStorage.getItem("ReselerUrl") + "/login";
    //}
    //else
    // {
    window.location.href = this._configuration.baseUrlToken + "/login";
    //}




  }

  sidebarchaged() {

    let width = window.innerWidth;
    if (width >= 1024) {
      let classActive = (document.getElementsByTagName("body")[0].className.indexOf("sidebar-collapse") != -1);
      if (classActive) {
        document.body.classList.remove("sidebar-collapse");
      }
      else {
        document.body.classList.add("sidebar-collapse");
      }

    }
    else {
      let classActive = (document.getElementsByTagName("body")[0].className.indexOf("sidebar-open") != -1);
      if (classActive) {
        document.body.classList.remove("sidebar-open");
      }
      else {
        document.body.classList.add("sidebar-open");
      }

    }

  }


}
